<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/unit/conversion/page" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('yuandanwei')">
            <yi_dictionary_select  :type="'UNIT_CONVERSION_TYPE'" :ids.sync="yt.conditions.sourceUnit">
            </yi_dictionary_select>
					</el-form-item>
					<el-form-item :label="$t('mubiaodanwei')">
            <yi_dictionary_select  :type="'UNIT_CONVERSION_TYPE'" :ids.sync="yt.conditions.targetUnit">
            </yi_dictionary_select>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary"
					v-if="ids == null&&utils.checkPower('web_system_unit_conversion_create')">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" v-if="utils.checkPower('web_unit_conversion_update')" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" :loading="yt.editObj.loading" v-if="utils.checkPower('web_unit_conversion_delete')" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/unit/conversion/delete')">{{$t('shanchu')}}</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
        :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('yuandanwei')" required>
            <yi_dictionary_select  :type="'UNIT_CONVERSION_TYPE'" :ids.sync="yt.editObj.sourceUnit">
            </yi_dictionary_select>
					</el-form-item>
					<el-form-item :label="$t('mubiaodanwei')" required>
            <yi_dictionary_select  :type="'UNIT_CONVERSION_TYPE'" :ids.sync="yt.editObj.targetUnit">
            </yi_dictionary_select>
					</el-form-item>
					<el-form-item :label="$t('huansuanxishu')" required>
						<el-input v-model="yt.editObj.coefficient"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST','/web/unit/conversion/create',beforeAdd)" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item class="noborder" :label="$t('yuandanwei')" required>
            <yi_dictionary_select disabled  :type="'UNIT_CONVERSION_TYPE'" :ids.sync="yt.editObj.sourceUnit">
            </yi_dictionary_select>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('mubiaodanwei')" required>
            <yi_dictionary_select disabled  :type="'UNIT_CONVERSION_TYPE'" :ids.sync="yt.editObj.targetUnit">
            </yi_dictionary_select>
          </el-form-item>
					<el-form-item :label="$t('huansuanxishu')" required>
						<el-input v-model="yt.editObj.coefficient"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST','/web/unit/conversion/update')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	export default {
		name: 'web_system_unit_conversion_list',

		data() {
			return {
				columns: [{
					label: 'yuandanweibianma',
					prop: 'sourceUnit',
					// type: 'dictionary',
					// key: 'UNIT_CONVERSION_TYPE',
					width: 130
				}, {
					label: 'yuandanwei',
					prop: 'sourceUnit',
          type: 'dictionary',
          key: 'UNIT_CONVERSION_TYPE',
					width: 130
				}, {
					label: 'mubiaodanweibianma',
					prop: 'targetUnit',
					// type: 'dictionary',
					// key: 'UNIT_CONVERSION_TYPE',
          width: 130
				}, {
					label: 'mubiaodanwei',
					prop: 'targetUnit',
          type: 'dictionary',
          key: 'UNIT_CONVERSION_TYPE',
				}, {
					label: 'huansuanxishu',
					prop: 'coefficient'
				}, {
					label: 'chuangjianren',
					prop: 'createByObject.nickname'
				}, {
					label: 'chuangjianshijian',
					prop: 'createTime',
					type: 'time',
					width: 150
				}, {
					label: 'caozuo',
					type: 'slot',
					width: 130,
					fixed: 'right'
				}]
			};
		},

		created() {
			setTimeout(() => {
				this.yt.get(1)
			}, 300)
		},
		methods: {
      // beforeAdd(params, url) {
      //   params.sourceUnit = params.sourceUnit+''
      //   return params
      // }
		}
	};
</script>
